import { InjectionToken } from '@angular/core';

export interface OptionCardsTranslations {
  currentOptionDescriptionHidden?: string;
  showMoreOptions?: string;
}

export const optionCardsDefaultTranslations: OptionCardsTranslations = {
  currentOptionDescriptionHidden: 'This is the current option.',
  showMoreOptions: 'Show more options'
};

export const OPTION_CARDS_TRANSLATIONS = new InjectionToken<OptionCardsTranslations>('OPTION_CARDS_TRANSLATIONS');
